// extracted by mini-css-extract-plugin
export var desc = "styles-module--desc--2ndaJ";
export var desc_text = "styles-module--desc_text--3baxl";
export var desc_date = "styles-module--desc_date--2V0Sc";